import React from "react"

export const WalletIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66634 13.3334H13.333C14.069 13.3334 14.6663 12.7361 14.6663 12.0001V6.66675H1.33301V12.0001C1.33301 12.7361 1.93034 13.3334 2.66634 13.3334ZM1.33301 5.33341V4.00008C1.33301 3.26408 1.93034 2.66675 2.66634 2.66675H13.333C14.069 2.66675 14.6663 3.26408 14.6663 4.00008V5.33341H1.33301Z"
        fill="#21A038"
      />
    </svg>
  )
}
